import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CommercialCredibility = () => {
  const majorClients = [
  {
    id: 1,
    name: "McDonald\'s",
    logo: "https://images.unsplash.com/photo-1627399581332-1437238c9861",
    logoAlt: "McDonald\'s golden arches logo on red background representing fast food restaurant chain partnership",
    description: "Complete plumbing and electrical installations across multiple locations",
    projectCount: "15+ Locations"
  },
  {
    id: 2,
    name: "KFC",
    logo: "https://images.unsplash.com/photo-1697616660956-6c0afd855125",
    logoAlt: "KFC Colonel Sanders logo in red and white representing fried chicken restaurant chain collaboration",
    description: "Emergency response and maintenance contracts for restaurant facilities",
    projectCount: "20+ Locations"
  },
  {
    id: 3,
    name: "Retail Chains",
    logo: "https://images.unsplash.com/photo-1651510039306-844c0b04e537",
    logoAlt: "Modern retail store interior with clothing racks and bright lighting representing commercial retail partnerships",
    description: "Complex electrical systems and plumbing infrastructure for major retail outlets",
    projectCount: "30+ Projects"
  }];


  const capabilities = [
  {
    icon: "Building2",
    title: "Commercial Installations",
    description: "Complete system design and installation for restaurants, retail, and commercial properties"
  },
  {
    icon: "Wrench",
    title: "Maintenance Contracts",
    description: "Ongoing support and preventive maintenance for commercial facilities"
  },
  {
    icon: "Clock",
    title: "Emergency Response",
    description: "Priority emergency service for commercial clients with guaranteed response times"
  },
  {
    icon: "Shield",
    title: "Quality Assurance",
    description: "Certified work with comprehensive warranties and compliance documentation"
  }];


  return (
    <section className="py-12 md:py-16 lg:py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 bg-accent/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Award" size={20} color="var(--color-accent)" />
            <span className="text-sm md:text-base font-semibold text-accent">Trusted by Major Brands</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-5xl font-bold text-foreground mb-4">
            Commercial Excellence
          </h2>
          
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto">
            Three decades of proven expertise serving South Africa's leading commercial brands with complex installations and reliable maintenance solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
          {majorClients?.map((client) =>
          <div key={client?.id} className="bg-card rounded-xl p-6 md:p-8 shadow-elevated hover:shadow-lg transition-all duration-300 border border-border">
              <div className="aspect-video mb-4 md:mb-6 rounded-lg overflow-hidden bg-muted">
                <Image
                src={client?.logo}
                alt={client?.logoAlt}
                className="w-full h-full object-cover" />

              </div>
              
              <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2 md:mb-3">{client?.name}</h3>
              
              <p className="text-sm md:text-base text-muted-foreground mb-4">
                {client?.description}
              </p>
              
              <div className="flex items-center gap-2 text-accent font-semibold">
                <Icon name="MapPin" size={18} />
                <span className="text-sm md:text-base">{client?.projectCount}</span>
              </div>
            </div>
          )}
        </div>

        <div className="bg-card rounded-2xl p-6 md:p-8 lg:p-12 shadow-elevated border border-border">
          <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground mb-6 md:mb-8 lg:mb-12 text-center">
            Commercial Service Capabilities
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {capabilities?.map((capability, index) =>
            <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-full mb-4">
                  <Icon name={capability?.icon} size={32} color="var(--color-primary)" />
                </div>
                
                <h4 className="text-base md:text-lg font-bold text-foreground mb-2">
                  {capability?.title}
                </h4>
                
                <p className="text-sm md:text-base text-muted-foreground">
                  {capability?.description}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default CommercialCredibility;